import { MDB_TYPES, CHECKLIST_STEP_TYPES, OPTION_TYPES } from "@meddbriefer/scenario-data";

// input: list of objects and a fieldName
// returns: an object who's attributes are the distinct values for that fieldName mapped to the subset
// of list items which share that field value
export const groupByKey = (listOfObjs, fldName) => listOfObjs.reduce(
    (hash, obj) => ({ ...hash, [obj[fldName]]: (hash[obj[fldName]] || []).concat(obj) }),
    {}
)

export const getChecklistItemsByType = (scenario, itemType) => {
    return scenario._checkListMetaData.filter(e => e.type === itemType)
}

export const getChecklistItems = (scenario) => {
  return scenario._checkListMetaData.filter(e => CHECKLIST_STEP_TYPES.includes(MDB_TYPES.PHASE, MDB_TYPES.SUB_PHASE))  
}

export const getChecklistHierarchy = (scenario) => {
    const phases = getChecklistItemsByType(scenario, MDB_TYPES.PHASE)
    const subPhases = getChecklistItemsByType(scenario, MDB_TYPES.SUB_PHASE)
    // filters out items which are display only
    const clSteps = scenario._checkListMetaData.filter(e => CHECKLIST_STEP_TYPES.includes(e.type))
    // get the options which are associated with some certain types of steps (decisions, assess w/options)
    const options = scenario._checkListMetaData.filter(e => OPTION_TYPES.includes(e.type))
    // map the options to their stepId
    const stepOptions = groupByKey(options, "parentID")
    // if a step has options, add them to that step
    clSteps.forEach(step => {
        if (step.id in stepOptions) {
            step.options = stepOptions[step.id]
        }
    })
    // figure out which checklist items belong to phases or subphases and group them by
    // the their corresponding phase/subphase ids
    const phChecklistSteps = groupByKey(clSteps.filter(e => undefined === e.subPhase), "phase")
    const spChecklistSteps = groupByKey(clSteps.filter(e => !!e.subPhase), "subPhase")
    // assign subphase steps to the appropriate subphase
    subPhases.forEach(sp => {
        sp.items = spChecklistSteps[sp.id]
    })
    // map subphases to their phase
    const phSubphases = groupByKey(subPhases, "phase")
    // phases have either items or subphases -not both. assign the appropriate stuff
    // to each phase
    phases.forEach(ph => {
        if (ph.id in phChecklistSteps) {
            ph.items = phChecklistSteps[ph.id]
        } else {
            ph.subPhases = phSubphases[ph.id]
        }
    })
    return phases
}